import React, { memo } from 'react';

import {
  convertDigitToProperFormat,
  convertNumbersToProperFormat,
} from 'utils/number';
import {
  IPrintPartProps,
  ExcludeExtraTaskProperties,
} from 'store/entity/IPrintTemplatePart';

import messages from './Messages';
import { SubTasksTable, WithoutSubTasks } from '../styles';
import { PrintPartSelector } from '../PrintSingleTask';
import {
  IPrintSingleTaskContext,
  PrintSingleTaskConsumer,
} from '../../../../../store/context/PrintSingleTaskContext';
import { smartDateString } from '../../../../../utils/date';
import { MainTBody, MoreInformationTable, MoreInformationTR } from './styles';

const SubTasksPartGenerator = (part: ExcludeExtraTaskProperties) => {
  return PrintPartSelector[part];
};

const SubTasksPart: React.FC<IPrintPartProps<'subTasks'>> = ({
  item: subTaskItem,
  property: subTasks,
}) => {
  const showProgress = subTaskItem.options.includeProgress ?? false;
  return (
    <PrintSingleTaskConsumer>
      {(dataContext: IPrintSingleTaskContext) => {
        const { members } = dataContext;

        const findUsersName = (id: number) => {
          return members?.find((value) => value.id === id)?.name;
        };
        return (
          <SubTasksTable>
            {subTasks.length > 0 ? (
              <>
                <thead>
                  <tr>
                    <th>{messages.tableIndex}</th>
                    {subTaskItem.options.tableHeader.map((item, index) => {
                      const SubTaskHeaderComponent = SubTasksPartGenerator(
                        item.part
                      );
                      const property = subTasks[0][item.part];
                      return (
                        <th
                          key={`${item.part}@${item.ref}[tableHeader${index}]`}
                        >
                          <SubTaskHeaderComponent
                            item={item}
                            taskId={subTasks[0].id}
                            property={property}
                          />
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                <MainTBody showProgress={showProgress}>
                  {subTasks
                    .sort((a, b) => {
                      return a.order - b.order;
                    })
                    .map((subTask, subTasksIndex) => (
                      <>
                        <tr key={subTask.id}>
                          <td>
                            <span>
                              {convertDigitToProperFormat(subTasksIndex + 1)}
                            </span>
                          </td>
                          {subTaskItem.options.tableBody.map((item, index) => {
                            const SubTaskBodyComponent = SubTasksPartGenerator(
                              item.part
                            );
                            const property = subTask[item.part];
                            return (
                              <>
                                <td
                                  key={`${item.part}@${item.ref}[tableBody${index}]`}
                                >
                                  <SubTaskBodyComponent
                                    item={item}
                                    taskId={subTask.id}
                                    property={property}
                                  />
                                </td>
                              </>
                            );
                          })}
                        </tr>
                        {showProgress &&
                          (() => {
                            const rows =
                              subTask.assignmentHistoryList?.filter(
                                (assignmentHistory: any) =>
                                  assignmentHistory.progress > 0
                              ) ?? [];
                            if (!rows.length) return <tr></tr>;
                            return (
                              <tr>
                                <td></td>
                                <td
                                  colSpan={
                                    subTaskItem.options.tableHeader.length
                                  }
                                  style={{
                                    padding: '0.5rem 5rem 0.5rem 0.25rem',
                                    background: 'var(--exact-white)',
                                  }}
                                >
                                  <MoreInformationTable>
                                    <colgroup>
                                      <col style={{ width: '40%' }} />
                                      <col style={{ width: '20%' }} />
                                      <col style={{ width: '20%' }} />
                                      <col style={{ width: '20%' }} />
                                    </colgroup>
                                    <MoreInformationTR>
                                      <th style={{ display: 'none' }}></th>
                                      <th>{messages.progressDate}</th>
                                      <th>{messages.progressPerson}</th>
                                      <th>{messages.progress}</th>
                                      <th>{subTask.assigneeTitle}</th>
                                    </MoreInformationTR>

                                    {rows.map((progressStep, index) => {
                                      return (
                                        <MoreInformationTR key={index}>
                                          <td style={{ display: 'none' }}></td>
                                          <td style={{ textAlign: 'center' }}>
                                            {`${smartDateString(progressStep.updateDate, false, true)}  :  ${progressStep.progressDescription || messages.noDescription}`}
                                          </td>
                                          <td>
                                            {findUsersName(
                                              progressStep.actorId!
                                            )}
                                          </td>
                                          <td>
                                            {convertNumbersToProperFormat(
                                              progressStep.progress,
                                              0
                                            )}
                                            {messages.percent}
                                          </td>
                                          <td>
                                            {findUsersName(
                                              progressStep.userId!
                                            )}
                                          </td>
                                        </MoreInformationTR>
                                      );
                                    })}
                                  </MoreInformationTable>
                                </td>
                              </tr>
                            );
                          })()}
                      </>
                    ))}
                </MainTBody>
              </>
            ) : (
              <WithoutSubTasks>{messages.withoutSubTasks}</WithoutSubTasks>
            )}
          </SubTasksTable>
        );
      }}
    </PrintSingleTaskConsumer>
  );
};

export default memo(SubTasksPart);
